"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WHITE_COLORS = exports.SHADE_CLEAR_ICON_SMALL_SIZE = exports.SHADE_CLEAR_ICON_SIZE = exports.SHADES_SMALL_SIZE = exports.SHADES_SIZE_CURRENT = exports.SHADES_SIZE = exports.SHADES_INLINE_SIZE = void 0;
const SHADES_SIZE = exports.SHADES_SIZE = 35;
const SHADES_SIZE_CURRENT = exports.SHADES_SIZE_CURRENT = 41;
const SHADE_CLEAR_ICON_SIZE = exports.SHADE_CLEAR_ICON_SIZE = '19px';
const SHADES_SMALL_SIZE = exports.SHADES_SMALL_SIZE = 14;
const SHADE_CLEAR_ICON_SMALL_SIZE = exports.SHADE_CLEAR_ICON_SMALL_SIZE = '10px';
const SHADES_INLINE_SIZE = exports.SHADES_INLINE_SIZE = 10;
const WHITE_COLORS = exports.WHITE_COLORS = ['white', '#fff', '#FFF', '#ffff', '#FFFF', '#ffffff', '#FFFFFF'];
